
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/claims-compliance/claims-unfair-handling-laws-regulations",
      function () {
        return require("private-next-pages/compliance/claims-compliance/claims-unfair-handling-laws-regulations.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/claims-compliance/claims-unfair-handling-laws-regulations"])
      });
    }
  